// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Heading-corrosion{
  color:#fff;
  padding: 10px;
  font-size: 12px;
}

.autocomplete-container .suggestions-container ul li a{

  font: normal normal normal 14px/25px Graphik !important;

  letter-spacing: 0px;

  color: #5C5C5C !important;

  padding: 0 5px !important;

}
.main-container {
  /* display: flex; */
  justify-content: space-around;
 width: 1150px;
  height: 500px;
  background-color: #202342;
  
}
.In-main-container{
  display: flex;
  flex-direction: row;
}


.links{
  color: #FFFFFF;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
}
.post-main-container{
  /* border: 1px solid lightgrey; */
  border-radius: 10px;
  height: 400px;
  justify-content: center;
  text-align: center;
}
.pre-subcontainer{
 
  display:flex;
  flex-direction:row;
  justify-content: center;
  /* margin-top: 50px; */
  height: 300px;
  margin-top: 20px;
  padding: 20px;
   /* border: 1px solid lightgrey;  */
  /* border-radius: 10px; */ 
  margin-left: 20px;
  margin-bottom: 20px;
  border:1px solid #747BA9;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}
.logo-container{
  display: flex;
  flex-direction: row;
  border: 1px solid black;
  height: 40px;
  /* width: 80%; */
  /* background-color: #002644; */
}
.GenAI{
  color: #FFFFFF;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
}
.Heading2{

  text-align: left;
  padding-left: 20px;
  color: #FFFFFF;
  font-family: 'Graphik', sans-serif;
  font-weight: 500;
}
.left-sub-container {
 
  
  width: 30%;
  color: #FFFFFF;
  font-family: 'Graphik', sans-serif;
}
.right-sub-container {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding-top: 10px;
  justify-content: center;
  text-align: center;
  height: 230px;
  width: 80%;
  color: #1D203C;
  font-family: 'Graphik', sans-serif;
  background-color: rgba(0, 0, 0, 0.1) ;
}
.plant-id-container{
 
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  width: 250px;
  height: 30px;

  /* text-align: center; */
}
.label-c{
  text-align: left;
  font-size: 13px;
  font-family: 'Graphik', sans-serif;
}
.upload-image-header{
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
}
.upload-image{
  color:white;
}
.drag-n-drop-files-containers{
  border: 1.5px dashed white;
  background-color: rgba(0, 0, 0, 0.1);
  margin-left: 25px;
  color:white;
  text-align: center;
  height: 135px;
  width :45%;
  border-radius: 10px;
}
.browse-logo{
  width: 35%;
  height: 70px;
  padding-top: 30px;
}
.or-option{
margin-top: 50px;
margin-left: 50px;
margin-right: 50px;
color: white;
font-family: Graphik;
font-weight: 600;
}
.browse-files-containers{
  border: 1px solid grey;
  background-color: rgba(54, 57, 85, 1);
  margin-right: 25px;
  color: white;
  text-align: center;
  height: 135px;
  width :45%;
  border-radius: 10px;
}

.asset-id-container{
  margin-top: 50px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  width: 250px;
  height: 30px;

  /* text-align: center; */
}
.Placeholder1{
  margin-top: 15px;
  font-family: 'Graphik', sans-serif;
  font-size: 14px;
  color:white;
  margin-left: 20px;
  margin-right: 20px;
}
.Placeholder4{
  margin-top: 15px;
  font-family: 'Graphik', sans-serif;
  font-size: 13px;
  color:white;
}
.Placeholder2{
  margin-top: 20px;
}
.upload-file-container {
  position: relative;
  overflow: hidden;
  
}

.upload-file-container input[type="file"] {
  height: 30px; /* Adjust the height as needed */
  padding: 10px;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.upload-file-button {
  font-size: 10px;
  font-size: 14px;
  font-family: Graphik;
  width: 50%;
  height: 35px;
  margin-top: 25px;
  margin-left: 20px;
  margin-right: 20px;
  color: #fff;
  border-radius: 50px;
  background-color: #6B5CD1;
  cursor: pointer;
}
.browse-text{
  margin-top: 5px;
  text-align: center;
}
select.corrosion-select {
  height: 25px; 
  width: 80%; 
  padding: 5px;
  margin-top: 5px;
  background-color: rgba(116, 123, 169, 1);
  font-size: 13px;
  color:white;
  border-radius: 5px;
}
/* select.asset-id-container{
  height: 25px; 
  width: 80%; 
  padding: 5px;
  margin-top: 5px;
  background-color: rgba(116, 123, 169, 1);
  font-size: 13px;
  color:white;
  border-radius: 5px;
} */
.select.placeholder{
  color: red;
}
.processbutton{
  margin-left: 860px;
  margin-top: 20px;
  border-radius: 50px;
  width: 200px;
  height: 40px;
  color: #FFFFFF;
  font-family: 'Graphik', sans-serif;
  font-size: 14px; 
  background-color: #6B5CD1;
  border-style: solid;
  border-width: 1px;
  border-color: #8d97dac5;
}
/* ... existing CSS ... */
.header-icon{
  /* width:100%; */
  height:40px;
  width:150%;
}

.footer {
  height: 20px;
  background-color: #f0f0f0;
  padding-bottom: 15px;
  font-size: 10px;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
}
/* ... existing CSS ... */

.info-icon {
  cursor: pointer;
  height: 2px;
  width: 1%;
  text-align: center;
  padding-top: 20px;
  margin-left: 900px;
}
.i-icon{
  width: 25px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  /* width: 100%;
  height: 100%; */
  /* margin-left: 100px;
  margin-top: 100px; */
  width:100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}



.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
/* Popup styling */
.pop-up-container-holder {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 2px solid black;
  padding: 10px;
  z-index: 1000;
  color: black;
}
/* Popup styling */
.pop-up-container-holder {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 2px solid black;
  padding: 10px;
  z-index: 1000;
  color: black;
}
.upload-success-message{
  color:white;
  padding-left:400px;
  
}



.pop-up-container-holder .left-popup-container {
  width: 34%;
}

.pop-up-container-holder .right-popup-container {
  width: 66%;
}

.pop-up-container-holder .left-popup-container .left-upper,
.pop-up-container-holder .right-popup-container .right-upper,
.pop-up-container-holder .left-popup-container .left-lower,
.pop-up-container-holder .right-popup-container .right-lower {
  border: 1px solid black;
  padding: 10px;
}

.pop-up-container-holder .left-popup-container .left-upper p,
.pop-up-container-holder .right-popup-container .right-upper p,
.pop-up-container-holder .left-popup-container .left-lower p,
.pop-up-container-holder .right-popup-container .right-lower p {
  margin: 0;
  padding: 5px;
  color: black;
}

.business-item{
  font-weight: 350;
  margin-bottom: 1px;
  font-size: 10px;
}
/* CorrosionPage.css */

/* Styles for the top section */
.top-section {
  display: flex;
}

/* Styles for the top-left section */
.top-left-sum {
  
  background-color: #ccc; /* Example background color */
  color: white;
  
  top: 0;
  left: 0;
  font-size: 12px;
}

/* Styles for the bottom-left section */
.bottom-left-sum {
 
 position: absolute;
  background-color: #eee; /* Example background color */
  color: white;
  font-size: 12px;
  margin-left: 210px;
  min-height: 200px;
  bottom: 0;
  left: 0;
}

/* Styles for the top-right section */
.top-right-sum {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #aaa; /* Example background color */
  color: white;
  font-size: 12px;
}

/* Styles for the bottom-right section */
.bottom-right-sum {
  margin-top: 300px;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-left: 500px;
 
  background-color: #ddd; /* Example background color */
  color: white;
  font-size: 12px;
}

/* Additional styles for your other elements can be defined below */

.modal-overlay-file {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* background-color: transparent; */
  color: #FFFFFF;
}

.modal-file {
  /* background-color: transparent; */
  width: 50px;
  height: 40px;
  padding: 20px;
  border-radius: 8px;
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5); */
}

.analysis-head2-file{
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 10px;
  padding-top: 10px;
  text-align: center;
}

.modal-overlay-corrosion {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  top: 0;
  left: 0;
}

.modal-corrosion{
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid #6B5CD1;
  border-radius: 8px;
  overflow-y: auto;
  /* margin-top: 50px; */
  height:90%;
}

.analysis-head-corrosion {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  padding: 10px;
  margin-left: 10px;
  position: relative;
}

.analysis-backdrop-corrosion {
  background-color: rgba(39, 40, 75, 1);
  margin-top: -9px;
  border-radius: 8px;
}

.close-icon-corrosion {
  font-size: 24px;
  position: absolute;
  cursor: pointer;
  color: blueviolet;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  width: 22px;
  /* margin-left: 430px; */
  left: 93%;
  position:absolute;
}
.close-img-corrosion {
  font-size: 24px;
  position: absolute;
  cursor: pointer;
  color: blueviolet;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  width: 22px;
  /* margin-left: 430px; */
  left: 72%;
  top: 23%;
  position:absolute;
}

.container-row-mail {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-family: Graphik;
  padding-top: 10px;
  color: white;
}

.modal-corrosion-mail{
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid #6B5CD1;
  border-radius: 8px;
  overflow-y: auto;
  /* margin-top: 50px; */
  height:90%;
  width: 50%;
}

.modal-mail-corrosion {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  top: 0;
  left: 0;
}

.modal-img-corrosion {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  top: 0;
  left: 0;
}

.modal-corrosion-img{
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid #6B5CD1;
  border-radius: 8px;
  overflow-y: auto;
  /* margin-top: 50px; */
  height:60%;
  width: 50%;
}

.container-data-mail {
  background-color: #25304C;
  width: 200px;
  min-height: 355px;
  min-width: 400px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  text-align: left;
  padding: 5px;
  color: white
}

.mail-content-corrosion{
  padding: 0px 20px;
}

.corrosion-mail-icon{
  width: 20px;
  cursor: pointer;
}
.corrosion-pdf-icon{
  width: 20px;
  margin-right: 5px;
  padding: 3px;
  cursor: pointer;
}
.corrosion-regenrate-icon{
  width: 23px;
  margin-right: 2px;
  /* padding: 3px; */
}
.corrosion-send-icon{
  width: 20px;
  margin-left: 5px;
}
.processe-corrosion-button {
  border-radius: 15px;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  width: fit-content;
  height: fit-content;
  border-style: solid;
  float: right;
  margin: 15px 10px 20px 0px;
  padding: 5px 10px;
  border: none;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/CorrosionPage.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,uDAAuD;;EAEvD,mBAAmB;;EAEnB,yBAAyB;;EAEzB,yBAAyB;;AAE3B;AACA;EACE,mBAAmB;EACnB,6BAA6B;CAC9B,aAAa;EACZ,aAAa;EACb,yBAAyB;;AAE3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,aAAa;GACZ,kCAAkC;EACnC,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;AACA;;;EAGE,UAAU;EACV,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;AACA;;EAEE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;;EAEZ,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;AACA;AACA,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,oBAAoB;AACpB,gBAAgB;AAChB;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;;EAEZ,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,YAAY,EAAE,gCAAgC;EAC9C,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;AACZ;AACA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;;;;;;;;;GASG;AACH;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA,yBAAyB;;AAEzB;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP;iBACe;EACf;sBACoB;EACpB,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;;AAEpB;;;;AAIA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;;EAIE,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,sBAAsB;;AAEtB,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;;EAEE,sBAAsB,EAAE,6BAA6B;EACrD,YAAY;;EAEZ,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;CAEC,kBAAkB;EACjB,sBAAsB,EAAE,6BAA6B;EACrD,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,OAAO;AACT;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,sBAAsB,EAAE,6BAA6B;EACrD,YAAY;EACZ,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;;EAElB,sBAAsB,EAAE,6BAA6B;EACrD,YAAY;EACZ,eAAe;AACjB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,MAAM;EACN,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,MAAM;EACN,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".Heading-corrosion{\r\n  color:#fff;\r\n  padding: 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.autocomplete-container .suggestions-container ul li a{\r\n\r\n  font: normal normal normal 14px/25px Graphik !important;\r\n\r\n  letter-spacing: 0px;\r\n\r\n  color: #5C5C5C !important;\r\n\r\n  padding: 0 5px !important;\r\n\r\n}\r\n.main-container {\r\n  /* display: flex; */\r\n  justify-content: space-around;\r\n width: 1150px;\r\n  height: 500px;\r\n  background-color: #202342;\r\n  \r\n}\r\n.In-main-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n\r\n.links{\r\n  color: #FFFFFF;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 12px;\r\n}\r\n.post-main-container{\r\n  /* border: 1px solid lightgrey; */\r\n  border-radius: 10px;\r\n  height: 400px;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n.pre-subcontainer{\r\n \r\n  display:flex;\r\n  flex-direction:row;\r\n  justify-content: center;\r\n  /* margin-top: 50px; */\r\n  height: 300px;\r\n  margin-top: 20px;\r\n  padding: 20px;\r\n   /* border: 1px solid lightgrey;  */\r\n  /* border-radius: 10px; */ \r\n  margin-left: 20px;\r\n  margin-bottom: 20px;\r\n  border:1px solid #747BA9;\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n  border-radius: 10px;\r\n}\r\n.logo-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  border: 1px solid black;\r\n  height: 40px;\r\n  /* width: 80%; */\r\n  /* background-color: #002644; */\r\n}\r\n.GenAI{\r\n  color: #FFFFFF;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 30px;\r\n}\r\n.Heading2{\r\n\r\n  text-align: left;\r\n  padding-left: 20px;\r\n  color: #FFFFFF;\r\n  font-family: 'Graphik', sans-serif;\r\n  font-weight: 500;\r\n}\r\n.left-sub-container {\r\n \r\n  \r\n  width: 30%;\r\n  color: #FFFFFF;\r\n  font-family: 'Graphik', sans-serif;\r\n}\r\n.right-sub-container {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 10px;\r\n  padding-top: 10px;\r\n  justify-content: center;\r\n  text-align: center;\r\n  height: 230px;\r\n  width: 80%;\r\n  color: #1D203C;\r\n  font-family: 'Graphik', sans-serif;\r\n  background-color: rgba(0, 0, 0, 0.1) ;\r\n}\r\n.plant-id-container{\r\n \r\n  margin-left: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 13px;\r\n  width: 250px;\r\n  height: 30px;\r\n\r\n  /* text-align: center; */\r\n}\r\n.label-c{\r\n  text-align: left;\r\n  font-size: 13px;\r\n  font-family: 'Graphik', sans-serif;\r\n}\r\n.upload-image-header{\r\n  display: flex;\r\n  flex-direction: row;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n.upload-image{\r\n  color:white;\r\n}\r\n.drag-n-drop-files-containers{\r\n  border: 1.5px dashed white;\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  margin-left: 25px;\r\n  color:white;\r\n  text-align: center;\r\n  height: 135px;\r\n  width :45%;\r\n  border-radius: 10px;\r\n}\r\n.browse-logo{\r\n  width: 35%;\r\n  height: 70px;\r\n  padding-top: 30px;\r\n}\r\n.or-option{\r\nmargin-top: 50px;\r\nmargin-left: 50px;\r\nmargin-right: 50px;\r\ncolor: white;\r\nfont-family: Graphik;\r\nfont-weight: 600;\r\n}\r\n.browse-files-containers{\r\n  border: 1px solid grey;\r\n  background-color: rgba(54, 57, 85, 1);\r\n  margin-right: 25px;\r\n  color: white;\r\n  text-align: center;\r\n  height: 135px;\r\n  width :45%;\r\n  border-radius: 10px;\r\n}\r\n\r\n.asset-id-container{\r\n  margin-top: 50px;\r\n  margin-left: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 13px;\r\n  width: 250px;\r\n  height: 30px;\r\n\r\n  /* text-align: center; */\r\n}\r\n.Placeholder1{\r\n  margin-top: 15px;\r\n  font-family: 'Graphik', sans-serif;\r\n  font-size: 14px;\r\n  color:white;\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n}\r\n.Placeholder4{\r\n  margin-top: 15px;\r\n  font-family: 'Graphik', sans-serif;\r\n  font-size: 13px;\r\n  color:white;\r\n}\r\n.Placeholder2{\r\n  margin-top: 20px;\r\n}\r\n.upload-file-container {\r\n  position: relative;\r\n  overflow: hidden;\r\n  \r\n}\r\n\r\n.upload-file-container input[type=\"file\"] {\r\n  height: 30px; /* Adjust the height as needed */\r\n  padding: 10px;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 15px;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  opacity: 0;\r\n}\r\n.upload-file-button {\r\n  font-size: 10px;\r\n  font-size: 14px;\r\n  font-family: Graphik;\r\n  width: 50%;\r\n  height: 35px;\r\n  margin-top: 25px;\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n  color: #fff;\r\n  border-radius: 50px;\r\n  background-color: #6B5CD1;\r\n  cursor: pointer;\r\n}\r\n.browse-text{\r\n  margin-top: 5px;\r\n  text-align: center;\r\n}\r\nselect.corrosion-select {\r\n  height: 25px; \r\n  width: 80%; \r\n  padding: 5px;\r\n  margin-top: 5px;\r\n  background-color: rgba(116, 123, 169, 1);\r\n  font-size: 13px;\r\n  color:white;\r\n  border-radius: 5px;\r\n}\r\n/* select.asset-id-container{\r\n  height: 25px; \r\n  width: 80%; \r\n  padding: 5px;\r\n  margin-top: 5px;\r\n  background-color: rgba(116, 123, 169, 1);\r\n  font-size: 13px;\r\n  color:white;\r\n  border-radius: 5px;\r\n} */\r\n.select.placeholder{\r\n  color: red;\r\n}\r\n.processbutton{\r\n  margin-left: 860px;\r\n  margin-top: 20px;\r\n  border-radius: 50px;\r\n  width: 200px;\r\n  height: 40px;\r\n  color: #FFFFFF;\r\n  font-family: 'Graphik', sans-serif;\r\n  font-size: 14px; \r\n  background-color: #6B5CD1;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #8d97dac5;\r\n}\r\n/* ... existing CSS ... */\r\n.header-icon{\r\n  /* width:100%; */\r\n  height:40px;\r\n  width:150%;\r\n}\r\n\r\n.footer {\r\n  height: 20px;\r\n  background-color: #f0f0f0;\r\n  padding-bottom: 15px;\r\n  font-size: 10px;\r\n  text-align: center;\r\n  position: fixed;\r\n  width: 100%;\r\n  bottom: 0;\r\n}\r\n/* ... existing CSS ... */\r\n\r\n.info-icon {\r\n  cursor: pointer;\r\n  height: 2px;\r\n  width: 1%;\r\n  text-align: center;\r\n  padding-top: 20px;\r\n  margin-left: 900px;\r\n}\r\n.i-icon{\r\n  width: 25px;\r\n}\r\n.modal {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  z-index: 1000;\r\n  top: 0;\r\n  left: 0;\r\n  /* width: 100%;\r\n  height: 100%; */\r\n  /* margin-left: 100px;\r\n  margin-top: 100px; */\r\n  width:100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n\r\n\r\n.close {\r\n  color: #aaa;\r\n  float: right;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.close:hover,\r\n.close:focus {\r\n  color: black;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n/* Popup styling */\r\n.pop-up-container-holder {\r\n  display: none;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  border: 2px solid black;\r\n  padding: 10px;\r\n  z-index: 1000;\r\n  color: black;\r\n}\r\n/* Popup styling */\r\n.pop-up-container-holder {\r\n  display: none;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  border: 2px solid black;\r\n  padding: 10px;\r\n  z-index: 1000;\r\n  color: black;\r\n}\r\n.upload-success-message{\r\n  color:white;\r\n  padding-left:400px;\r\n  \r\n}\r\n\r\n\r\n\r\n.pop-up-container-holder .left-popup-container {\r\n  width: 34%;\r\n}\r\n\r\n.pop-up-container-holder .right-popup-container {\r\n  width: 66%;\r\n}\r\n\r\n.pop-up-container-holder .left-popup-container .left-upper,\r\n.pop-up-container-holder .right-popup-container .right-upper,\r\n.pop-up-container-holder .left-popup-container .left-lower,\r\n.pop-up-container-holder .right-popup-container .right-lower {\r\n  border: 1px solid black;\r\n  padding: 10px;\r\n}\r\n\r\n.pop-up-container-holder .left-popup-container .left-upper p,\r\n.pop-up-container-holder .right-popup-container .right-upper p,\r\n.pop-up-container-holder .left-popup-container .left-lower p,\r\n.pop-up-container-holder .right-popup-container .right-lower p {\r\n  margin: 0;\r\n  padding: 5px;\r\n  color: black;\r\n}\r\n\r\n.business-item{\r\n  font-weight: 350;\r\n  margin-bottom: 1px;\r\n  font-size: 10px;\r\n}\r\n/* CorrosionPage.css */\r\n\r\n/* Styles for the top section */\r\n.top-section {\r\n  display: flex;\r\n}\r\n\r\n/* Styles for the top-left section */\r\n.top-left-sum {\r\n  \r\n  background-color: #ccc; /* Example background color */\r\n  color: white;\r\n  \r\n  top: 0;\r\n  left: 0;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Styles for the bottom-left section */\r\n.bottom-left-sum {\r\n \r\n position: absolute;\r\n  background-color: #eee; /* Example background color */\r\n  color: white;\r\n  font-size: 12px;\r\n  margin-left: 210px;\r\n  min-height: 200px;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n/* Styles for the top-right section */\r\n.top-right-sum {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  background-color: #aaa; /* Example background color */\r\n  color: white;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Styles for the bottom-right section */\r\n.bottom-right-sum {\r\n  margin-top: 300px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  margin-left: 500px;\r\n \r\n  background-color: #ddd; /* Example background color */\r\n  color: white;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Additional styles for your other elements can be defined below */\r\n\r\n.modal-overlay-file {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  /* background-color: transparent; */\r\n  color: #FFFFFF;\r\n}\r\n\r\n.modal-file {\r\n  /* background-color: transparent; */\r\n  width: 50px;\r\n  height: 40px;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5); */\r\n}\r\n\r\n.analysis-head2-file{\r\n  color: #FFFFFF;\r\n  font-family: 'Graphik';\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  padding-bottom: 10px;\r\n  padding-top: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.modal-overlay-corrosion {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 10000;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.modal-corrosion{\r\n  background-color: rgba(30, 32, 61, 1);\r\n  border: 1px solid #6B5CD1;\r\n  border-radius: 8px;\r\n  overflow-y: auto;\r\n  /* margin-top: 50px; */\r\n  height:90%;\r\n}\r\n\r\n.analysis-head-corrosion {\r\n  color: #FFFFFF;\r\n  font-family: 'Graphik';\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n  padding: 10px;\r\n  margin-left: 10px;\r\n  position: relative;\r\n}\r\n\r\n.analysis-backdrop-corrosion {\r\n  background-color: rgba(39, 40, 75, 1);\r\n  margin-top: -9px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.close-icon-corrosion {\r\n  font-size: 24px;\r\n  position: absolute;\r\n  cursor: pointer;\r\n  color: blueviolet;\r\n  background-color: transparent;\r\n  border: none;\r\n  border-radius: 5px;\r\n  width: 22px;\r\n  /* margin-left: 430px; */\r\n  left: 93%;\r\n  position:absolute;\r\n}\r\n.close-img-corrosion {\r\n  font-size: 24px;\r\n  position: absolute;\r\n  cursor: pointer;\r\n  color: blueviolet;\r\n  background-color: transparent;\r\n  border: none;\r\n  border-radius: 5px;\r\n  width: 22px;\r\n  /* margin-left: 430px; */\r\n  left: 72%;\r\n  top: 23%;\r\n  position:absolute;\r\n}\r\n\r\n.container-row-mail {\r\n  display: flex;\r\n  flex-direction: row;\r\n  font-size: 12px;\r\n  font-family: Graphik;\r\n  padding-top: 10px;\r\n  color: white;\r\n}\r\n\r\n.modal-corrosion-mail{\r\n  background-color: rgba(30, 32, 61, 1);\r\n  border: 1px solid #6B5CD1;\r\n  border-radius: 8px;\r\n  overflow-y: auto;\r\n  /* margin-top: 50px; */\r\n  height:90%;\r\n  width: 50%;\r\n}\r\n\r\n.modal-mail-corrosion {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 10000;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.modal-img-corrosion {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 10000;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.modal-corrosion-img{\r\n  background-color: rgba(30, 32, 61, 1);\r\n  border: 1px solid #6B5CD1;\r\n  border-radius: 8px;\r\n  overflow-y: auto;\r\n  /* margin-top: 50px; */\r\n  height:60%;\r\n  width: 50%;\r\n}\r\n\r\n.container-data-mail {\r\n  background-color: #25304C;\r\n  width: 200px;\r\n  min-height: 355px;\r\n  min-width: 400px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-radius: 5px;\r\n  border-color: #8d97dac5;\r\n  text-align: left;\r\n  padding: 5px;\r\n  color: white\r\n}\r\n\r\n.mail-content-corrosion{\r\n  padding: 0px 20px;\r\n}\r\n\r\n.corrosion-mail-icon{\r\n  width: 20px;\r\n  cursor: pointer;\r\n}\r\n.corrosion-pdf-icon{\r\n  width: 20px;\r\n  margin-right: 5px;\r\n  padding: 3px;\r\n  cursor: pointer;\r\n}\r\n.corrosion-regenrate-icon{\r\n  width: 23px;\r\n  margin-right: 2px;\r\n  /* padding: 3px; */\r\n}\r\n.corrosion-send-icon{\r\n  width: 20px;\r\n  margin-left: 5px;\r\n}\r\n.processe-corrosion-button {\r\n  border-radius: 15px;\r\n  position: absolute;\r\n  color: rgba(255, 255, 255, 1);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-size: 15px;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  border-style: solid;\r\n  float: right;\r\n  margin: 15px 10px 20px 0px;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
